module.exports = __webpack_public_path__ + "img/icon2.1021e1e6.png";